// English translations for React Admin (using default messages from react-admin)

const englishMessages = {
    ra: {
        action: {
            add_filter: 'Add filter',
            add: 'Add',
            back: 'Go Back',
            bulk_actions: '%{smart_count} selected',
            cancel: 'Cancel',
            clear_array_input: 'Clear the list',
            clear_input_value: 'Clear value',
            clone: 'Clone',
            confirm: 'Confirm',
            create: 'Create',
            create_item: 'Create %{item}',
            delete: 'Delete',
            edit: 'Edit',
            export: 'Export',
            list: 'List',
            refresh: 'Refresh',
            remove_filter: 'Remove this filter',
            remove_all_filters: 'Remove all filters',
            remove: 'Remove',
            save: 'Save',
            search: 'Search',
            select_all: 'Select all',
            select_row: 'Select this row',
            show: 'Show',
            sort: 'Sort',
            undo: 'Undo',
            unselect: 'Unselect',
            expand: 'Expand',
            close: 'Close',
            open_menu: 'Open menu',
            close_menu: 'Close menu',
            update: 'Update',
            move_up: 'Move up',
            move_down: 'Move down',
            open: 'Open',
            toggle_theme: 'Toggle Theme',
            select_columns: 'Columns',
            reset: 'Reset',
            search_columns: 'Search columns',
            select_all_button: 'Select all',
            update_application: 'Reload Application',
        },
        boolean: {
            true: 'Yes',
            false: 'No',
            null: ' ',
        },
        page: {
            create: 'Create %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Something went wrong',
            list: '%{name}',
            loading: 'Loading',
            not_found: 'Not Found',
            show: '%{name} #%{id}',
            empty: 'No %{name} yet.',
            invite: 'Do you want to add one?',
        },
        input: {
            file: {
                upload_several: 'Drop some files to upload, or click to select one.',
                upload_single: 'Drop a file to upload, or click to select it.',
            },
            image: {
                upload_several: 'Drop some pictures to upload, or click to select one.',
                upload_single: 'Drop a picture to upload, or click to select it.',
            },
            references: {
                all_missing: 'Unable to find references data.',
                many_missing: 'At least one of the associated references no longer appears to be available.',
                single_missing: 'Associated reference no longer appears to be available.',
            },
            password: {
                toggle_visible: 'Hide password',
                toggle_hidden: 'Show password',
            },
        },
        message: {
            about: 'About',
            are_you_sure: 'Are you sure?',
            bulk_delete_content: 'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
            bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name}',
            bulk_update_content: 'Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?',
            bulk_update_title: 'Update %{name} |||| Update %{smart_count} %{name}',
            delete_content: 'Are you sure you want to delete this item?',
            delete_title: 'Delete %{name} #%{id}',
            details: 'Details',
            error: 'A client error occurred and your request could not be completed.',
            invalid_form: 'The form is not valid. Please check for errors',
            loading: 'The page is loading, just a moment please',
            no: 'No',
            not_found: 'Either you typed a wrong URL, or you followed a bad link.',
            yes: 'Yes',
            unsaved_changes: "Some of your changes weren't saved. Are you sure you want to ignore them?",
        },
        navigation: {
            no_results: 'No results found',
            no_more_results: 'The page number %{page} is out of boundaries. Try the previous page.',
            page_out_of_boundaries: 'Page number %{page} out of boundaries',
            page_out_from_end: 'Cannot go after last page',
            page_out_from_begin: 'Cannot go before page 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
            partial_page_range_info: '%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}',
            current_page: 'Page %{page}',
            page: 'Go to page %{page}',
            first: 'Go to first page',
            last: 'Go to last page',
            next: 'Next',
            previous: 'Previous',
            page_rows_per_page: 'Rows per page:',
            skip_nav: 'Skip to content',
        },
        sort: {
            sort_by: 'Sort by %{field} %{order}',
            ASC: 'ascending',
            DESC: 'descending',
        },
        auth: {
            auth_check_error: 'Please login to continue',
            user_menu: 'Profile',
            username: 'Username',
            password: 'Password',
            sign_in: 'Sign in',
            sign_in_error: 'Authentication failed, please retry',
            logout: 'Logout',
        },
        notification: {
            updated: 'Element updated |||| %{smart_count} elements updated',
            created: 'Element created',
            deleted: 'Element deleted |||| %{smart_count} elements deleted',
            bad_item: 'Incorrect element',
            item_doesnt_exist: 'Element does not exist',
            http_error: 'Server communication error',
            data_provider_error: 'dataProvider error. Check the console for details.',
            i18n_error: 'Cannot load the translations for the specified language',
            canceled: 'Action cancelled',
            logged_out: 'Your session has ended, please reconnect.',
        },
        validation: {
            required: 'Required',
            minLength: 'Must be %{min} characters at least',
            maxLength: 'Must be %{max} characters or less',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Must be a number',
            email: 'Must be a valid email',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match a specific format (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Saved queries',
            query_name: 'Query name',
            new_label: 'Save current query...',
            new_dialog_title: 'Save current query as',
            remove_label: 'Remove saved query',
            remove_label_with_name: 'Remove query "%{name}"',
            remove_dialog_title: 'Remove saved query?',
            remove_message: 'Are you sure you want to remove that item from your list of saved queries?',
            help: 'Filter the list and save this query for later',
        },
        configurable: {
            customize: 'Customize',
            configureMode: 'Configure this page',
            inspector: {
                title: 'Inspector',
                content: 'Hover the application UI elements to configure them',
                reset: 'Reset Settings',
                hideAll: 'Hide All',
                showAll: 'Show All',
            },
            Datagrid: {
                title: 'Datagrid',
                unlabeled: 'Unlabeled column #%{column}',
            },
            SimpleForm: {
                title: 'Form',
                unlabeled: 'Unlabeled input #%{input}',
            },
            SimpleList: {
                title: 'List',
                primaryText: 'Primary text',
                secondaryText: 'Secondary text',
                tertiaryText: 'Tertiary text',
            },
        },
    },
};

export const en = {
    ...englishMessages,
    resources: {
        companies: {
            name: 'Company |||| Companies',
            fields: {
                name: 'Name',
                alias: 'Company alias',
                aliasHelp: 'Optional display name. When set, it is shown everywhere instead of the formal company name.',
                customerNumber: 'Customer number',
                customerNumberHelp: 'Unique customer number. The azubi:web customer range starts at 10000.',
                contactPerson: 'Contact person',
                email: 'Email',
                phone: 'Phone',
                street: 'Street',
                addressSupplement1: 'Address supplement 1',
                addressSupplement2: 'Address supplement 2',
                zip: 'ZIP Code',
                city: 'City',
                country: 'Country',
                billingEmail: 'Invoice email',
                billingEmailHelp: 'Invoices are sent to this address. Empty = the company default email.',
                billingStreet: 'Billing Street',
                billingZip: 'Billing ZIP Code',
                billingCity: 'Billing City',
                billingCountry: 'Billing Country',
                taxId: 'Tax ID / VAT Number',
                commercialRegister: 'Commercial Register Number',
                website: 'Website',
                active: 'Active',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
                isDemoTenant: 'Demo tenant',
                isDemoTenantHelp: 'Demo tenants are deactivated by the daily cleanup cron once their expiry date is reached.',
                expiresAt: 'Demo expires',
                expiresAtHelp: 'Only relevant for demo tenants. Empty = no expiry.',
                publicRegistrationEnabled: 'Public registration',
                publicRegistrationEnabledHelp: 'Lets external visitors register themselves through a landing page and buy courses there. Without this, guest checkout fails with an error.',
                parentCompany: 'Parent company',
                parentCompanyHelp: 'Assigns this tenant to a company group (e.g. a hotel chain). Tenants of the same group can see group-only marketplace listings.',
                subsidiaries: 'Subsidiaries',
            },
            tabs: {
                general: 'General',
                address: 'Address',
                billing: 'Billing Address',
                legal: 'Legal Information',
                demo: 'Demo',
                group: 'Company group',
                licenses: 'Licenses',
            },
        },
        users: {
            name: 'User |||| Users',
            fields: {
                email: 'Email',
                emailLockedHelp: 'Email addresses can only be changed by superadmins.',
                firstName: 'First Name',
                lastName: 'Last Name',
                phone: 'Phone',
                mobile: 'Mobile',
                street: 'Street',
                zip: 'ZIP Code',
                city: 'City',
                country: 'Country',
                dateOfBirth: 'Date of Birth',
                jobTitle: 'Job Title',
                department: 'Department',
                language: 'Preferred Language',
                company: 'Company',
                roles: 'Roles',
                userRoles: 'Roles',
                password: 'Password',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                contact: 'Contact & Address',
                work: 'Work Information',
                personal: 'Personal',
                roles: 'Roles & Permissions',
            },
        },
        roles: {
            name: 'Role |||| Roles',
            fields: {
                name: 'Name',
                description: 'Description',
                permissions: 'Permissions',
                application: 'Product',
            },
        },
        permissions: {
            name: 'Permission |||| Permissions',
            fields: {
                name: 'Name',
                description: 'Description',
            },
        },
        products: {
            name: 'Product |||| Products',
            fields: {
                name: 'Name',
                description: 'Description',
                price: 'Price',
                application: 'Application',
                active: 'Active',
                permissions: 'Permissions',
                currentPermissions: 'Current Permissions',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                permissions: 'Permissions',
                metadata: 'Metadata',
            },
        },
        licenses: {
            name: 'License |||| Licenses',
            fields: {
                company: 'Company',
                product: 'Product',
                startDate: 'Valid from',
                expiresAt: 'Valid until',
                expiresAtHelp: 'Leave empty for lifetime license',
                validFrom: 'Valid from',
                validUntil: 'Valid until',
                maxUsers: 'Max. Users',
                active: 'Active',
                status: 'Status',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                metadata: 'Metadata',
            },
            status: {
                active: 'Active',
                inactive: 'Inactive',
                expired: 'Expired',
                lifetime: 'Lifetime',
            },
        },
        invitations: {
            name: 'Invitation |||| Invitations',
            fields: {
                email: 'Email',
                company: 'Company',
                roles: 'Roles',
                token: 'Token',
                createdAt: 'Created at',
                expiresAt: 'Expires at',
                used: 'Used',
                usedAt: 'Used at',
                invitedBy: 'Invited by',
                registeredUser: 'Registered User',
            },
        },
        'learning-groups': {
            name: 'Learning Group |||| Learning Groups',
            fields: {
                name: 'Name',
                description: 'Description',
                memberCount: 'Members',
                maxMembers: 'Max Members',
                isPublic: 'Public',
                courseTitle: 'Course',
                createdAt: 'Created at',
            },
            public: 'Public',
            private: 'Private',
        },
        'peer-review-assignments': {
            name: 'Peer Review |||| Peer Reviews',
            fields: {
                lessonTitle: 'Lesson',
                submitterUserId: 'Submitter',
                reviewerUserId: 'Reviewer',
                status: 'Status',
                submission: 'Submission',
                hasAttachment: 'Has Attachment',
                attachmentFilename: 'Attachment',
                assignedAt: 'Assigned at',
                completedAt: 'Completed at',
            },
            status: {
                pending: 'Pending',
                inReview: 'In Review',
                completed: 'Completed',
            },
        },
    },
    custom: {
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        passwordChanged: 'Password changed successfully',
        language: 'Language',
        profile: {
            menuItem: 'My Profile',
            title: 'My Profile',
            notLoggedIn: 'You are not logged in',
        },
    },
    admin: {
        dashboard: {
            welcome: 'Welcome to Admin Dashboard',
            quickAccess: 'Quick Access',
            stats: {
                companies: 'Companies',
                users: 'Users',
                invitations: 'Invitations',
                roles: 'Roles',
                products: 'Products',
                licenses: 'Licenses',
            },
            expiredLicenses: {
                title: 'Tenant Without a Valid License |||| Tenants Without a Valid License',
                message: 'One tenant has no valid license — sign-in is blocked there. |||| %{smart_count} tenants have no valid license — sign-in is blocked there.',
            },
            deletionRequests: {
                title: 'Deletion requests',
                requestedAt: 'Requested on %{requestedAt} · Decision by %{dueAt}',
                approve: 'Approve',
                reject: 'Reject',
                approveTitle: 'Delete account?',
                approveText: "%{name}'s account will be anonymized and locked. This cannot be undone.",
                approveConfirm: 'Delete account',
                approved: 'Account deleted.',
                rejectTitle: 'Reject deletion request',
                rejectReason: 'Reason',
                rejectHelp: 'The person will receive the reason by email.',
                rejected: 'Request rejected.',
                cancel: 'Cancel',
            },
            expiringLicenses: {
                title: 'License Expiring Soon |||| Licenses Expiring Soon',
                message: 'One license will expire within the next 30 days. |||| %{smart_count} licenses will expire within the next 30 days.',
            },
            recentActivity: {
                title: 'Recent Activity',
                subtitle: 'Monitor the latest changes in the system',
                activeUsers: 'active users',
                registeredCompanies: 'registered companies',
                issuedLicenses: 'issued licenses',
            },
            systemOverview: {
                title: 'System Overview',
                subtitle: 'Management of permissions and access',
                definedRoles: 'Defined Roles',
                availableProducts: 'Available Products',
                openInvitations: 'Open Invitations',
                activeLicenses: 'Active Licenses',
                expiredLicensesWarning: 'One tenant without a valid license |||| %{smart_count} tenants without a valid license',
                expiringLicensesWarning: 'One license expiring within 30 days |||| %{smart_count} licenses expiring within 30 days',
            },
        },
        menu: {
            dashboard: 'Dashboard',
            companies: 'Companies',
            users: 'Users',
            invitations: 'Invitations',
            roles: 'Roles',
            permissions: 'Permissions',
            products: 'Products',
            licenses: 'Licenses',
            learningGroups: 'Learning Groups',
            peerReviews: 'Peer Reviews',
            learningPaths: 'Learning Paths',
            analytics: 'Analytics & Reports',
            templates: 'Document Templates',
            organizationSettings: 'Organization Settings',
            brandingSettings: 'Branding Settings',
            documents: 'Documents',
            legalDocuments: 'Legal Documents',
            paymentSettings: 'Payment Settings',
            orders: 'Orders',
            landingPages: 'Landing Pages',
            marketplace: 'Marketplace',
            licensedCourses: 'Licensed Courses',
            profile: 'Profile',
            changePassword: 'Change Password',
            logout: 'Logout',
            help: 'Help',
            language: 'Language',
            loadingTranslations: 'Loading translations...',
        },
        bottomNav: {
            dashboard: 'Dashboard',
            companies: 'Companies',
            users: 'Users',
            roles: 'Roles',
            permissions: 'Permissions',
            products: 'Products',
            licenses: 'Licenses',
        },
    },
    companyOnboarding: {
        title: 'Create New Tenant',
        wizardButton: 'Create Tenant (Wizard)',
        steps: {
            company: 'Company',
            license: 'License',
            admin: 'Administrator',
            summary: 'Summary',
            companyTitle: 'Company Details',
            companyDescription: 'Enter the basic information for the new company.',
            licenseTitle: 'Configure License',
            licenseDescription: 'Select the product and configure the license.',
            adminTitle: 'Create Administrator',
            adminDescription: 'Create the first administrator for this company.',
            summaryTitle: 'Summary',
            summaryDescription: 'Review all entries before creating the tenant.',
        },
        fields: {
            companyName: 'Company Name',
            companyEmail: 'Email Address',
            companyPhone: 'Phone',
            companyDomain: 'Domain',
            companyDomainHelp: 'Optional custom domain for white-label (e.g., company.academy)',
            companyWebsite: 'Website',
            street: 'Street',
            zip: 'ZIP Code',
            city: 'City',
            country: 'Country',
            product: 'Product',
            includedPermissions: 'Included Permissions',
            more: 'more',
            hasExpiration: 'License with expiration date',
            lifetimeLicenseInfo: 'Without an expiration date, a lifetime license will be created.',
            licenseExpiresAt: 'License valid until',
            sendInvitation: 'Send invitation via email',
            invitationInfo: 'The administrator will receive an email with a registration link.',
            directUserInfo: 'The administrator will be created directly with the specified credentials.',
            adminEmail: 'Email Address',
            adminFirstName: 'First Name',
            adminLastName: 'Last Name',
            adminPassword: 'Password',
            passwordHelp: 'Minimum 10 characters',
        },
        sections: {
            address: 'Address',
            userDetails: 'User Details',
        },
        buttons: {
            next: 'Next',
            back: 'Back',
            cancel: 'Cancel',
            finish: 'Create Tenant',
        },
        summary: {
            company: 'Company',
            license: 'License',
            admin: 'Administrator',
            lifetime: 'Lifetime',
            adminType: 'Type',
            invitation: 'Invitation',
            directUser: 'Direct User',
            role: 'Role',
        },
        adminRoleInfo: 'The administrator will receive the ROLE_COMPANY_ADMIN role and have full access to company management.',
        success: 'Tenant created successfully!',
        errors: {
            companyNameRequired: 'Company name is required.',
            productRequired: 'Please select a product.',
            adminEmailRequired: 'Administrator email address is required.',
            firstNameRequired: 'First name is required.',
            lastNameRequired: 'Last name is required.',
            passwordMinLength: 'Password must be at least 12 characters long.',
            loadProductsFailed: 'Failed to load products.',
            unknown: 'An unknown error occurred.',
            network: 'Network error - please try again.',
        },
    },
    registration: {
        title: 'Complete Your Registration',
        company: 'Company',
        email: 'Email',
        assignedRoles: 'Assigned Roles',
        fields: {
            firstName: 'First Name',
            lastName: 'Last Name',
            password: 'Password',
            confirmPassword: 'Confirm Password',
            passwordHelp: 'Minimum 10 characters',
            phone: 'Phone',
            mobile: 'Mobile',
            street: 'Street',
            zip: 'ZIP',
            city: 'City',
            country: 'Country',
            jobTitle: 'Job Title',
            department: 'Department',
            none: 'None',
        },
        buttons: {
            submit: 'Complete Registration',
            goToLogin: 'Go to Login',
        },
        errors: {
            noToken: 'No invitation token provided.',
            invalidToken: 'Invalid or expired invitation.',
            validationFailed: 'Failed to validate invitation. Please try again.',
            passwordMismatch: 'Passwords do not match.',
            passwordTooShort: 'Password must be at least 10 characters long.',
            registrationFailed: 'Registration failed. Please try again.',
            networkError: 'Failed to register. Please try again.',
        },
        success: {
            title: 'Registration Successful!',
            message: 'Your account has been created successfully. You will be redirected to the login page...',
        },
        error: {
            title: 'Registration Error',
        },
    },
    marketplace: {
        title: 'Marketplace',
        browse: 'Browse Marketplace',
        myListings: 'My Listings',
        myLicenses: 'My Licenses',
        mySales: 'My Sales',
        noListings: 'No courses available in the marketplace.',
        noLicenses: 'You have not licensed any courses yet.',
        noSales: 'You have not sold any courses yet.',
        noOwnListings: 'You have not published any courses to the marketplace yet.',
        licenseType: {
            reference: 'Reference',
            copy: 'Copy',
        },
        purchase: {
            title: 'License Course',
            selectType: 'Select license type',
            referenceDescription: 'Live link, updates are automatically synchronized',
            copyDescription: 'Independent copy, you can customize the course',
            processing: 'Processing...',
            success: 'License successfully acquired!',
            alreadyLicensed: 'You have already licensed this course.',
        },
        listing: {
            create: 'Publish Course',
            edit: 'Edit Listing',
            selectCourse: 'Select course',
            customTitle: 'Display title (optional)',
            customTitleHelp: 'Leave empty to use course title',
            priceReference: 'Price Reference License',
            priceCopy: 'Price Copy License',
            allowReference: 'Allow reference licensing',
            allowCopy: 'Allow copy licensing',
            revenueShare: 'Revenue Share (%)',
            revenueShareHelp: 'Your share of the sale price',
            isActive: 'Active (visible in marketplace)',
            success: 'Course published successfully!',
            updated: 'Listing updated!',
            deleted: 'Listing deleted!',
        },
        stats: {
            totalRevenue: 'Total Revenue',
            licenses: 'Licenses',
            enrollments: 'Enrollments',
        },
    },
};
